type Theme = 'GC' | 'SC';

export const switchTheme = (theme: Theme) => {
    const root = document.documentElement;
    if (theme === 'GC') {
        root.setAttribute('data-theme', 'GC');
        // const darkThemeStylesheet = document.createElement('link');
        // darkThemeStylesheet.rel = 'stylesheet';
        // darkThemeStylesheet.href = `/theme/gc-theme.css`;
        // document.head.appendChild(darkThemeStylesheet);
        // // 移除SC主题样式表（如果存在）
        // const existingLightTheme = document.querySelector(`link[href="/theme/sc-theme.css"]`);
        // if (existingLightTheme) {
        //     existingLightTheme.remove();
        // }

    }
    if (theme === 'SC') {
        root.setAttribute('data-theme', 'SC');
        // const lightThemeStylesheet = document.createElement('link');
        // lightThemeStylesheet.rel = 'stylesheet';
        // lightThemeStylesheet.href = `/theme/sc-theme.css`;
        // document.head.appendChild(lightThemeStylesheet);
        // // 移除GC主题样式表（如果存在）
        // const existingDarkTheme = document.querySelector('link[href="/theme/gc-theme.css"]');
        // if (existingDarkTheme) {
        //     existingDarkTheme.remove();
        // }
    }
}
